import { Icon, IconProps } from './Icon';

interface FilterIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const FilterIcon = ({ color = '#5E6A81', gradient, ...props }: FilterIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 20 20"
  >
    {gradient && (
      <defs>
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      </defs>
    )}
    <path
      d="M12.083 11.2497L16.4222 6.91051C16.5788 6.75384 16.6663 6.54217 16.6663 6.32134V4.16634C16.6663 3.70634 16.293 3.33301 15.833 3.33301H4.16634C3.70634 3.33301 3.33301 3.70634 3.33301 4.16634V6.32134C3.33301 6.54217 3.42051 6.75467 3.57717 6.91051L7.91634 11.2497"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M7.91699 11.25V16.4575C7.91699 17.135 8.55366 17.6325 9.21116 17.4683L11.2945 16.9475C11.7578 16.8317 12.0837 16.415 12.0837 15.9367V11.25"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
